import type { RootState } from 'old-store/store';

// optional: the shop's own stores and test stores have no new-gallery slice
export const selectPendingSelectionEdit = (state: RootState) =>
  state.scrAppBookNew?.ui?.pendingSelectionEdit ?? null;
